import { AUDIT_DEFAULT_WINDOW_DAYS } from '@pams/shared';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  EVERY WORD THE AUDIT LOG PAGE SAYS. [ANALYTICS §8]
 *
 *  One file, so prose carries a test — `DASHBOARD_COPY`'s and `USAGE_ANALYTICS_COPY`'s reason.
 *
 *  ⚠️ THE EMPTY STATE SAYS THE WINDOW IS A DEFAULT, NOT RETENTION. With no dates chosen the API reads
 *  the last `AUDIT_DEFAULT_WINDOW_DAYS` IST days; the log itself is permanent. An empty page that
 *  said only "nothing recorded" would read as "nothing was ever recorded", and the next question is
 *  whether the log is being purged — which it is not: no request path, job or migration removes a
 *  row, and the one command that does (`pnpm reset:db`) is development-only and empties everything.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const AUDIT_LOG_COPY = {
  title: 'Audit log',
  subtitle: (total: number): string =>
    `${total.toLocaleString('en-IN')} recorded ${total === 1 ? 'change' : 'changes'} — who changed what, and when`,
  filters: {
    what: 'What',
    whatPlaceholder: 'Anything',
    action: 'Action',
    actionPlaceholder: 'Any action',
    who: 'Who',
    whoPlaceholder: 'Anyone — search by name or phone',
    from: 'From',
    fromPlaceholder: `${AUDIT_DEFAULT_WINDOW_DAYS} days ago`,
    to: 'To',
    toPlaceholder: 'Today',
    only: (name: string): string => `Only: ${name}`,
    clear: 'Clear filters',
  },
  columns: {
    when: 'When',
    who: 'Who',
    action: 'Action',
    entity: 'Entity',
    changed: 'What changed',
  },
  unknownOfficer: 'Unknown officer',
  gone: 'no longer exists',
  onlyThisOfficer: 'Only this officer',
  onlyThis: 'Only this',
  empty: {
    filtered: 'No recorded changes match these filters.',
    unfiltered: `Nothing recorded in the last ${AUDIT_DEFAULT_WINDOW_DAYS} days — the log is permanent; choose earlier dates.`,
  },
  error: 'The audit log could not be loaded.',
} as const;
